import React from 'react';
import { StarIcon, MoreVerticalIcon } from 'lucide-react';
import { mockApps } from '../../utils/mockData';
import { getIcon } from '../../utils/iconUtils';
import { useNavigate } from 'react-router-dom';
interface AppListViewProps {
  onOpenApp: (appId: string) => void;
  createAppTile?: any;
}
export const AppListView = ({
  onOpenApp,
  createAppTile
}: AppListViewProps) => {
  const navigate = useNavigate();
  // Mobile card view
  const MobileListView = () => <div className="md:hidden space-y-4" data-id="element-257">
      {mockApps.map(app => <div key={app.id} className="bg-white p-4 rounded-lg border border-gray-200 shadow-sm" onClick={() => navigate(`/app-interface/${app.id}`)} data-id="element-258">
          <div className="flex items-center space-x-3" data-id="element-259">
            <div className={`${app.iconBg} w-10 h-10 rounded-lg flex items-center justify-center flex-shrink-0`} data-id="element-260">
              {getIcon(app.icon)}
            </div>
            <div className="flex-1 min-w-0" data-id="element-261">
              <h3 className="font-medium text-gray-900 truncate" data-id="element-262">
                {app.title}
              </h3>
              <p className="text-sm text-gray-500 truncate" data-id="element-263">{app.author}</p>
            </div>
            <button className="p-2 text-gray-400 hover:text-gray-600" data-id="element-264">
              <MoreVerticalIcon className="h-5 w-5" data-id="element-265" />
            </button>
          </div>
          <div className="mt-3 flex items-center justify-between" data-id="element-266">
            <div className="flex items-center" data-id="element-267">
              <StarIcon className="h-4 w-4 text-amber-400 fill-amber-400" data-id="element-268" />
              <span className="ml-1 text-sm font-medium" data-id="element-269">{app.rating}</span>
            </div>
            <div className="text-sm text-gray-500" data-id="element-270">{app.category}</div>
            <div className="text-sm text-gray-500" data-id="element-271">{app.updated}</div>
          </div>
        </div>)}
    </div>;
  // Desktop table view
  const DesktopListView = () => <div className="hidden md:block overflow-hidden bg-white rounded-lg border border-gray-200" data-id="element-272">
      <div className="overflow-x-auto" data-id="element-273">
        <table className="min-w-full divide-y divide-gray-200" data-id="element-274">
          <thead className="bg-gray-50" data-id="element-275">
            <tr data-id="element-276">
              <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-277">
                App
              </th>
              <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-278">
                Category
              </th>
              <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-279">
                Rating
              </th>
              <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-280">
                Last Used
              </th>
              <th scope="col" className="relative px-6 py-3" data-id="element-281">
                <span className="sr-only" data-id="element-282">Actions</span>
              </th>
            </tr>
          </thead>
          <tbody className="bg-white divide-y divide-gray-200" data-id="element-283">
            {mockApps.map(app => <tr key={app.id} className="hover:bg-gray-50 cursor-pointer" onClick={() => navigate(`/app-interface/${app.id}`)} data-id="element-284">
                <td className="px-6 py-4 whitespace-nowrap" data-id="element-285">
                  <div className="flex items-center" data-id="element-286">
                    <div className={`${app.iconBg} w-8 h-8 rounded-lg flex items-center justify-center`} data-id="element-287">
                      {getIcon(app.icon)}
                    </div>
                    <div className="ml-4" data-id="element-288">
                      <div className="text-sm font-medium text-gray-900" data-id="element-289">
                        {app.title}
                      </div>
                      <div className="text-sm text-gray-500" data-id="element-290">{app.author}</div>
                    </div>
                  </div>
                </td>
                <td className="px-6 py-4 whitespace-nowrap" data-id="element-291">
                  <span className="text-sm text-gray-900" data-id="element-292">{app.category}</span>
                </td>
                <td className="px-6 py-4 whitespace-nowrap" data-id="element-293">
                  <div className="flex items-center" data-id="element-294">
                    <StarIcon className="h-4 w-4 text-amber-400 fill-amber-400" data-id="element-295" />
                    <span className="ml-1 text-sm text-gray-900" data-id="element-296">
                      {app.rating}
                    </span>
                  </div>
                </td>
                <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500" data-id="element-297">
                  {app.updated}
                </td>
                <td className="px-6 py-4 whitespace-nowrap text-right text-sm font-medium" data-id="element-298">
                  <button className="text-gray-400 hover:text-gray-600 p-2" onClick={e => {
                e.stopPropagation();
                // Handle menu click
              }} data-id="element-299">
                    <MoreVerticalIcon className="h-5 w-5" data-id="element-300" />
                  </button>
                </td>
              </tr>)}
          </tbody>
        </table>
      </div>
    </div>;
  return <>
      <MobileListView data-id="element-301" />
      <DesktopListView data-id="element-302" />
    </>;
};